<template>
  <div class="wish-detail-page">
    <SubPageHeader title="祝福记录" />
    
    <div class="content" v-if="!isLoading && info">
      <div class="top-section">
        <div class="heart-icon">
          <img src="@/assets/img/org/xinxin.png" alt="heart" />
        </div>
        <div class="date">{{ formatDate(info.createdAt) }}</div>
        <div class="wish-content">{{ info.content }}</div>
      </div>
      
      <div class="info-section">
        <div class="info-row">
          <span class="label">许愿人</span>
          <span class="value">{{ info.uidName || '--' }}</span>
        </div>
        <div class="info-row">
          <span class="label">许愿人手机</span>
          <span class="value">{{ info.uidMobile || '--' }}</span>
        </div>
        <div class="info-row">
          <span class="label">许愿人地址</span>
          <span class="value">{{ info.uidAddress || '--' }}</span>
        </div>
        <div class="info-row">
          <span class="label">许愿人简介</span>
          <span class="value">{{ info.uidBref || '暂无简介' }}</span>
        </div>
        <div class="info-row" v-if="info.imgUrl && info.imgUrl.length > 0">
          <span class="label"></span>
          <div class="value images">
            <img v-for="(img, idx) in info.imgUrl" :key="idx" :src="img.url" class="wish-img" alt="图片" />
          </div>
        </div>
        <div class="info-row">
          <span class="label">心愿状态</span>
          <span class="value">{{ getStatusText(info.wishStat) }}</span>
        </div>
        
        <!-- 未完成，当前用户认领时显示表单 -->
        <div class="info-row input-row" v-if="info.wishStat === 1 && !info.finishedContent && isCurrentUserPicker">
          <span class="label">完成说明</span>
          <div class="value input-value">
            <el-input 
              v-model="finishedContent" 
              type="textarea" 
              :rows="3" 
              placeholder="请输入完成说明" 
            />
          </div>
        </div>
        <div class="info-row input-row" v-if="info.wishStat === 1 && !info.finishedContent && isCurrentUserPicker">
          <span class="label">图片</span>
          <div class="value input-value">
            <el-upload
              class="wish-uploader flex-start"
              action="#"
              :http-request="customUpload"
              :show-file-list="true"
              :before-upload="beforeUpload"
              :limit="3"
              v-model:file-list="finishedImgList"
              list-type="picture-card"
              accept="image/*"
            >
              <el-icon><Plus /></el-icon>
            </el-upload>
          </div>
        </div>

        <!-- 已完成的展示内容 -->
        <div class="info-row" v-if="info.finishedContent">
          <span class="label">完成说明</span>
          <span class="value">{{ info.finishedContent }}</span>
        </div>
        <div class="info-row" v-if="info.finishedContent && info.finishedImgUrl && info.finishedImgUrl.length > 0">
          <span class="label">完成图片</span>
          <div class="value images">
            <img v-for="(img, idx) in info.finishedImgUrl" :key="'finish_'+idx" :src="img.url" class="wish-img" alt="完成图片" />
          </div>
        </div>
      </div>
      
      <div class="bottom-action">
        <!-- 只有待认领和已认领才能点击，其他状态禁用 -->
        <button class="action-btn" :class="{ disabled: getButtonDisabled() }" @click="handleAction">
          {{ getButtonText() }}
        </button>
      </div>
    </div>
    <div v-else-if="isLoading" class="loading-text">
      加载中...
    </div>
  </div>
</template>

<script>
import SubPageHeader from '../component/SubPageHeader.vue';
import { getWishInfo, pickWish, finishWish, uploadFile } from '@/api';
import toast from '@/components/toast';
import { getCachedUserProfile } from '@/utils/profile';
import { Plus } from '@element-plus/icons-vue';

export default {
  name: 'MicroWishDetailPage',
  components: {
    SubPageHeader,
    Plus
  },
  data() {
    return {
      isLoading: false,
      info: null,
      currentUserProfile: getCachedUserProfile(),
      finishedContent: '',
      finishedImgList: [],
      uploadLoading: false
    };
  },
  computed: {
    isCurrentUserPicker() {
      if (!this.info || !this.currentUserProfile) return false;
      // Compare current user ID with uidHas
      return Number(this.currentUserProfile.info?.id) === Number(this.info.uidHas);
    }
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      this.fetchWishInfo(id);
    }
  },
  methods: {
    async fetchWishInfo(id) {
      this.isLoading = true;
      try {
        const res = await getWishInfo({ id });
        if (res && res.data) {
          this.info = res.data;
        }
      } catch (error) {
        console.error('Failed to fetch wish info:', error);
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.split(' ')[0];
    },
    getStatusText(wishStat) {
      if (wishStat === 0) return '待认领';
      if (wishStat === 1) return '已认领';
      if (wishStat === 2) return '已过期';
      return '--';
    },
    getButtonText() {
      if (!this.info) return '领取';
      if (this.info.finishedContent) return '已完成';
      if (this.info.wishStat === 0) return '领取';
      if (this.info.wishStat === 1) {
        if (!this.info.finishedContent && this.isCurrentUserPicker) {
          return '提交完成';
        }
        return '已领取';
      }
      if (this.info.wishStat === 2) return '已过期';
      return '领取';
    },
    getButtonDisabled() {
      if (!this.info) return true;
      if (this.info.finishedContent) return true;
      if (this.info.wishStat === 0) return false;
      if (this.info.wishStat === 1) {
        if (!this.info.finishedContent && this.isCurrentUserPicker) {
          if (this.uploadLoading) return true;
          if (!this.finishedContent || !this.finishedContent.trim()) return true;
          if (!this.finishedImgList || this.finishedImgList.length === 0) return true;
          
          const hasInvalid = this.finishedImgList.some(item => {
            return item.status !== 'success' || !item.url || item.url.startsWith('blob:');
          });
          
          return hasInvalid;
        }
        return true;
      }
      return true;
    },
    async handleAction() {
      if (this.getButtonDisabled()) return;

      if (this.info.wishStat === 0) {
        // 领取操作
        try {
          const res = await pickWish({ wishId: this.info.id });
          if (res && res.stat === 1) {
            toast('领取成功！');
            this.fetchWishInfo(this.info.id);
          }
        } catch (error) {
          console.error('Failed to claim wish:', error);
        }
      } else if (this.info.wishStat === 1 && this.isCurrentUserPicker) {
        // 提交完成操作
        try {
          const imgUrls = this.finishedImgList.map(item => {
            return {
              type: 'image',
              url: item.url,
              name: item.name || '现场照片.jpg'
            };
          });

          const res = await finishWish({
            id: this.info.id,
            finishedContent: this.finishedContent,
            finishedImgUrl: imgUrls
          });

          if (res && res.stat === 1) {
            toast('提交成功！');
            this.fetchWishInfo(this.info.id);
          }
        } catch (error) {
          console.error('Failed to finish wish:', error);
        }
      }
    },
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        toast('上传图片大小不能超过 10MB!');
        return false;
      }
      return true;
    },
    extractUploadedUrl(payload) {
      if (!payload) {
        return ''
      }
      if (typeof payload === 'string') {
        return payload
      }
      const root = payload?.data || payload
      if (typeof root === 'string') {
        return root
      }
      const cloudUrl = root?.cloudResult?.url || root?.cloud_result?.url
      if (cloudUrl) {
        return cloudUrl
      }
      const directUrl = root?.url || root?.fileUrl || root?.file_url || root?.path
      if (directUrl) {
        return directUrl
      }
      const fullPath = root?.fullPath || root?.full_path
      if (!fullPath) {
        return ''
      }
      if (/^https?:\/\//.test(fullPath)) {
        return fullPath
      }
      return fullPath.startsWith('/') ? fullPath : `/${fullPath}`
    },
    async customUpload(option) {
      this.uploadLoading = true;
      try {
        const res = await uploadFile(option.file);
        const fileUrl = this.extractUploadedUrl(res);
        if (!fileUrl) {
          throw new Error('未获取到上传地址');
        }
        
        option.onSuccess?.(res);
        
        const fileItem = this.finishedImgList.find(f => f.uid === option.file.uid);
        if (fileItem) {
          fileItem.url = fileUrl;
        }
      } catch (error) {
        toast('图片上传失败，请重试');
        option.onError?.(error);
      } finally {
        this.uploadLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.wish-detail-page {
  min-height: 100vh;
  background: #ffffff;
  padding-bottom: 20vw;
}

.content {
  background: #ffffff;
  padding: 6vw 4vw;
}

.top-section {
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 4vw;
  margin-bottom: 4vw;
  
  .heart-icon {
    margin-bottom: 2vw;
    display: flex;
    justify-content: center;
    
    img {
      width: 14vw;
      height: 14vw;
      object-fit: contain;
    }
  }
  
  .date {
    font-size: 3.2vw;
    color: #999999;
    margin-bottom: 4vw;
  }
  
  .wish-content {
    font-size: 4vw;
    color: #333333;
    text-align: left;
    word-break: break-all;
  }
}

.info-section {
  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 3vw 0;
    font-size: 3.5vw;
    
    .label {
      color: #666666;
      width: 25vw;
      flex-shrink: 0;
    }
    
    .value {
      color: #333333;
      text-align: right;
      flex: 1;
      word-break: break-all;
      
      &.images {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 2vw;
      }
    }
    
    &.input-row {
      align-items: stretch;
      
      .label {
        line-height: 8vw;
      }
      
      .input-value {
        text-align: left;
      }
    }
  }
}

.wish-img {
  width: 20vw;
  height: 20vw;
  object-fit: cover;
  border-radius: 1vw;
}

:deep(.wish-uploader) {
  display: flex;
  justify-content: flex-end;
  
  &.flex-start {
    justify-content: flex-start;
    
    .el-upload-list--picture-card {
      justify-content: flex-start;
    }
  }
  
  .el-upload--picture-card {
    width: 20vw;
    height: 20vw;
    line-height: 20vw;
    border-radius: 1vw;
  }
  .el-upload-list--picture-card {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 20vw;
    height: 20vw;
    border-radius: 1vw;
  }
}

.bottom-action {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 4vw;
  background: #ffffff;
  box-shadow: 0 -0.5vw 2vw rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  
  .action-btn {
    width: 100%;
    height: 12vw;
    border-radius: 6vw;
    background: #ff5e62;
    color: #ffffff;
    font-size: 4vw;
    font-weight: 500;
    border: none;
    outline: none;
    cursor: pointer;
    box-shadow: 0 1vw 3vw rgba(255, 94, 98, 0.3);
    
    &.disabled {
      opacity: 0.8;
    }
  }
}

.loading-text {
  text-align: center;
  color: #999;
  padding: 10vw 0;
  font-size: 3.8vw;
}
</style>
